import { SampleBreakdownUnit, SampleCategories } from 'api';
import { SelectField, TextField, useFieldArray, useFormContext } from 'form';
import { useTranslation } from 'i18n';
import { Box, Button, IconButton, Stack, Typography } from 'ui';
import { Add, Close } from 'ui/icons';

const nameOptions = Object.values(SampleCategories).map((value) => ({
  label: value.replace(/_/g, ' '),
  value,
}));

const unitOptions = Object.values(SampleBreakdownUnit).map((value) => ({
  label: value.replace(/_/g, ' '),
  value,
}));

export const DefaultBreakdownFormFields = () => {
  const { t } = useTranslation('features');
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'breakdown',
  });

  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Typography variant="body1" fontWeight="bold">
        {t('evidence.defaultBreakdownFormFields.title')}
      </Typography>
      {fields.map((field, index) => (
        <Stack
          key={field.id}
          direction="row"
          sx={{
            alignItems: 'flex-top',
            gap: 2,
          }}
        >
          <SelectField
            name={`breakdown.${index}.name`}
            options={nameOptions}
            label={t('evidence.defaultBreakdownFormFields.labels.name')}
            required
          />

          <TextField
            name={`breakdown.${index}.value`}
            label={t('evidence.defaultBreakdownFormFields.labels.value')}
            required
          />

          <SelectField
            name={`breakdown.${index}.unit`}
            options={unitOptions}
            label={t('evidence.defaultBreakdownFormFields.labels.unit')}
            required
          />

          <Box>
            <IconButton onClick={() => remove(index)} data-testid="remove-breakdown-item">
              <Close />
            </IconButton>
          </Box>
        </Stack>
      ))}
      <Button
        variant="secondary"
        sx={{ alignSelf: 'end' }}
        startIcon={<Add />}
        onClick={() => append({ name: '', unit: '', value: '' })}
      >
        {t('evidence.defaultBreakdownFormFields.actions.addBreakdownItem')}
      </Button>
    </Stack>
  );
};
